<template>
  <!-- Experience Modal -->
  <div id="select_report_user_modal" class="modal custom-modal fade" role="dialog" ref="myModal">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Select Employees</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ref="Close">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <form>
            <div class="form-scroll">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <h3 class="card-title">
                      Filter
                    </h3>


                    <div class="col-md-6">
                      <!-- <div class="input-block mb-3 form-focus focused">
                        <input
                          type="text"
                          class="form-control floating"
                          value="United States"
                        />
                        <label class="focus-label">Location</label>
                      </div> -->
                      <v-autocomplete v-model="selectedRoles" :items="companyRole" label="Roles" multiple variant="outlined"
                        density="comfortable" closable-chips item-title="text" item-value="id" chips></v-autocomplete>
                    </div>
                    <div class="col-md-6">
                      <!-- <div class="input-block mb-3 form-focus focused">
                        <input
                          type="text"
                          class="form-control floating"
                          value="Web Developer"
                        />
                        <label class="focus-label">Job Position</label>
                      </div> -->
                      <v-autocomplete v-model="selectedLocations" :items="locationIdOptions" label="Locations" multiple
                        variant="outlined" density="comfortable" closable-chips item-title="text" item-value="id"
                        chips></v-autocomplete>
                    </div>
                    <div class="justify-content-md-end d-md-flex d-grid">
                      <button class="btn btn-primary" type="button" @click="applyFilterClicked">Apply Filters</button>
                    </div>
                    <h3 class="card-title mt-3">
                      Selected Employees
                    </h3>
                    <div class=" col-12">
                      <!-- <div class="input-block mb-3 form-focus focused">
                        <input
                          type="text"
                          class="form-control floating"
                          value="Digital Devlopment Inc"
                        />
                        <label class="focus-label floating">Users</label>
                      </div> -->
                      <v-autocomplete v-model="selectedUsers" :items="usersData" label="Select Users" multiple
                        variant="outlined" density="comfortable" item-title="text" item-value="id" closable-chips
                        chips></v-autocomplete>
                    </div>
                    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                      <button class="btn btn-primary me-md-2" type="button" @click="selectClicked">Select All</button>
                      <button class="btn btn-primary" type="button" @click="unselectClicked">Unselect All</button>
                    </div>
                    <!-- <div class="text-end">
              <button class="btn btn-primary"></button>

              
              <button class="btn btn-primary ma-3"></button>
            </div> -->

                  </div>

                </div>
              </div>

            </div>
            <div class="submit-section">
              <button class="btn btn-primary submit-btn" type="button" @click="okClicked">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Experience Modal -->


</template>
<script>
import axios from 'axios';
import { VUE_APP_API_BASE_URL } from "../../config";
export default {
  data() {
    return {
      select2: null,

      perPage: 10,
      current: 1,
      total: 0,

      usersData: [],
      companyRole: [],
      locationIdOptions: [],
      loader: false,

      selectedUsers: [],
      selectedLocations: [],
      selectedRoles: [],
    };
  },
  mounted() {
    this.getCompanyRoles(),
      this.getUsers(),
      this.getLocationIds()
  },
  methods: {
    async getCompanyRoles() {
      await axios.get(`${VUE_APP_API_BASE_URL}/company-role/get`)
        .then((response) => {
          if (response.data.status) {
            this.companyRole = response.data.data
            this.companyRole.forEach(element => {
              delete element['created_at'];
              delete element['updated_at'];
              element['text'] = element['name'];
              delete element['name'];
            });
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    },

    getUsers() {
      this.loader = true;

      axios.get(`${VUE_APP_API_BASE_URL}/user/user-list`)
        .then((response) => {
          if (response.data.status) {
            this.usersData = response.data.data;

            this.usersData.forEach(element => {
              element["text"] = element["first_name"] + " " + element["last_name"];
            });
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },
    async getLocationIds() {
      await axios.get(`${VUE_APP_API_BASE_URL}/location/all`)
        .then((response) => {
          if (response.data.status) {
            this.locationIdOptions = response.data.data
            this.locationIdOptions.forEach(element => {
              delete element['created_at'];
              delete element['updated_at'];
              delete element['latitude'];
              delete element['longitude'];
              element['text'] = element['name'];
              delete element['name'];
            }
            )
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        })
        .finally(() => {

        });
    },
    unselectClicked() {
      this.selectedUsers = null;
    },
    selectClicked() {
      this.selectedUsers = this.usersData.map(user => user.id);
    },
    applyFilterClicked() {
      if (
        this.selectedLocations.length == 0 &&
        this.selectedRoles.length == 0
      ) {
        this.$toast.error("Cannot apply filter. No role or location selected");
        return;
      }

      this.unselectClicked();
      let filterUsers = [];

      filterUsers = this.usersData.filter(user => {
        const roleMatch =
          !this.selectedRoles.length || this.selectedRoles.includes(user.company_role_id)

        const locationMatch =
          !this.selectedLocations.length || this.selectedLocations.includes(user.location_id)

        return roleMatch && locationMatch
      });
      this.selectedUsers = filterUsers.map(user => user.id)
      if (!this.selectedUsers.length) {
        this.$toast.error("No User for the selected role or location");
      }
    },
    okClicked() {
      if (this.selectedUsers.length == 0) {
        this.$toast.error("No users selected");
        return;
      }
      this.$emit('onUsersSelected', this.selectedUsers);
      this.selectedUsers = [];
      this.selectedLocations = [];
      this.selectedRoles = [];
      this.$refs.Close.click();
    },
  },

};
</script>
